import React, { useEffect, useState } from 'react';
import './App.css'
import { Routes, Route, Navigate } from 'react-router-dom';
import MapLibreView from './Components/Map/MapLibre';
import Navbar from './Components/UserInterface/Header';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import LoginPage from './authentication/LoginPage';
import { getRuntimeConfig } from './runtime-config';
// import appInsights from './MSAppInsights/AppInsights';
// import RouteTracker from "./MSAppInsights/AppInsights";

const config = getRuntimeConfig();

function App() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [authState, setAuthState] = useState('loading');
  const [userRole, setUserRole] = useState('None');
  const [accessDenied, setAccessDenied] = useState(false);
  const azure_maps_id = config.AZ_MAPS_CLIENTID;


  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const redirectResult = await instance.handleRedirectPromise();
        const account = redirectResult?.account ?? instance.getAllAccounts()[0];

        if (!account) {
          console.log("No accounts found");
          return;
        }

        instance.setActiveAccount(account);

        
        try {
          const graphToken = await instance.acquireTokenSilent({
            scopes: ["User.Read"],
            account,
          });
          const graphResponse = await fetch("https://graph.microsoft.com/v1.0/me", {
            headers: { Authorization: `Bearer ${graphToken.accessToken}` },
          });
          const response = await fetch('https://graph.microsoft.com/v1.0/me?$select=department', {
            headers: {
              'Authorization': `Bearer ${graphToken.accessToken}`
            }
          });
          const user = await response.json();
          const data = await graphResponse.json();
          setUserRole(data.jobTitle);
          sessionStorage.setItem('jobrole', data.jobTitle);

        } catch (error) {
          console.error("Error fetching user profile:", error);
        }

    
        let mapsToken;
        try {
          mapsToken = await instance.acquireTokenSilent({
            scopes: ["https://atlas.microsoft.com/user_impersonation"],
            account,
          });
        } catch (error) {
          
          console.warn("Maps token silent acquisition failed (non-fatal, likely first-load timing):", error);
          return;
        }

       
        try {
          const mapsResponse = await fetch(
            `https://atlas.microsoft.com/search/address/json?api-version=1.0&query=Berlin&countrySet=DE&limit=1`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${mapsToken.accessToken}`,
                "x-ms-client-id": azure_maps_id,
              },
            }
          );

         
          if (mapsResponse.status === 401 || mapsResponse.status === 403) {
            setAccessDenied(true);
          }
        } catch (error) {
          
          console.warn("Maps access check fetch failed (non-fatal):", error);
        }

      } catch (error) {
        if (error.errorCode !== 'no_token_request_cache_error') {
          console.error("Auth error:", error);
        }
      } finally {
        setAuthState('ready');
      }
    };

    if (authState === 'loading') {
      handleRedirect();
    }
  }, [instance, authState]);

  // Activate after teams channel is created

  const openOutlook = () => {
    const subject = `BauGIS | Zugriff Anfragen`;
    const body = `ich möchte Zugriff auf BauGIS erhalten.`;
    const mailtoLink = `mailto:bim-support@goldbeck.de?&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  if (authState === 'loading') {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        flexDirection: 'column'
      }}>
        <div>Loading authentication...</div>
        <div style={{ fontSize: '12px', marginTop: '10px', color: '#666' }}>
          Handling authentication redirect...
        </div>
      </div>
    );
  }

  if (isAuthenticated && accessDenied) {
    return (
      <>
        <Navbar title='BauGIS' />
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100vh - 60px)',
          backgroundColor: '#ffffff',
        }}>
          <div style={{
            backgroundColor: '#ffffff',
            border: '1px solid #ffffff',
            borderLeft: '4px solid #ffffff',
            borderRadius: '8px',
            width: '100%',
            boxSizing: 'border-box',
            overflow: 'auto',
            textAlign: 'center',
          }}>
            <div style={{
              height: '100vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
              <img
                src="\assets\GB_LogoWordMark.png"
                alt="logo"
                style={{
                  marginTop: '100px',
                  width: '200px',
                  height: 'auto',
                }}
              />
              <img
                src="\assets\AccessDenied.png"
                alt="logo"
                style={{
                  marginTop: '-100px',
                  width: '600px',
                  height: 'auto',
                }}
              />
              <h2 style={{ color: '#4d4d4d', marginTop: '-35px', fontSize: '13px', width: '438px', height: '55px' }}>
                Du hast derzeit keine Zugriffsberechtigung für diese Seite. Falls du Zugriff benötigst, kontaktiere bitte das BauGIS-Team.
              </h2>
              <button
                onClick={openOutlook}
                style={{
                  backgroundColor: '#3EBAEC',
                  color: 'white',
                  padding: '10px 24px',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '14px',
                  cursor: 'pointer',
                  marginTop: '10px',
                  width: '216px',
                  height: '40px',
                  outline: 'none',
                  transition: 'opacity 0.2s ease',
                }}
                onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                onMouseLeave={(e) => (e.target.style.opacity = 1)}
              >
                Zugriff anfragen
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar title='BauGIS' />
      {/* <RouteTracker jobRole={userRole}></RouteTracker> */}
      <Routes>
        {isAuthenticated ? (
          <>
            <Route path="/" element={<MapLibreView />} />
            <Route path="/3d-view" element={<MapLibreView />} />
            <Route path="/auth/callback" element={<Navigate to="/" replace />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </>
  );
}

export default App;